import { render, staticRenderFns } from "./downloads.vue?vue&type=template&id=403dd964&scoped=true&"
import script from "./downloads.vue?vue&type=script&lang=ts&"
export * from "./downloads.vue?vue&type=script&lang=ts&"
import style0 from "./downloads.vue?vue&type=style&index=0&id=403dd964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403dd964",
  null
  
)

export default component.exports